import type { ReactNode } from 'react';

import config from 'config';
import { Layout } from 'ui/components/primitives';

import { Container, ButtonContainer, HeaderPageContainer } from './HeaderPage.styles';

export const HeaderPage = ({
  children,
  button,
  testid,
}: {
  children: ReactNode;
  button?: ReactNode;
  testid?: string;
}) => (
  <HeaderPageContainer data-testid={testid}>
    <Layout alternateColor={true}>
      <Container
        marginBottom="sp-0"
        marginTop="sp-0"
        horizontalAlign="center"
        data-has-button={!!button}
      >
        <div data-has-button={!!button} data-brand={config.app.short}>
          {children}
          {button && <ButtonContainer>{button}</ButtonContainer>}
        </div>
      </Container>
    </Layout>
  </HeaderPageContainer>
);

export default HeaderPage;
